/**
 * Microsoft Clarity event name constants
 * Use these constants when tracking events with Clarity to ensure consistency
 */

// Navigation events
export const NAVIGATION_EVENTS = {
  HOME_TAB_CLICK: "home_tab_click",
  COMPANY_TAB_CLICK: "company_tab_click",
  CAMPAIGNS_TAB_CLICK: "campaigns_tab_click",
  METRICS_TAB_CLICK: "metrics_tab_click",
  USERS_TAB_CLICK: "users_tab_click",
  SYSTEM_HEALTH_TAB_CLICK: "system_health_tab_click",
  SETTINGS_NAVIGATION: "settings_navigation",
};

// User interaction events
export const USER_EVENTS = {
  PROFILE_MENU_OPEN: "profile_menu_open",
  PROFILE_MENU_CLOSE: "profile_menu_close",
  USER_LOGOUT: "user_logout",
};

// UI interaction events
export const UI_EVENTS = {
  SIDEBAR_TOGGLE: "sidebar_toggle",
  SIDEBAR_EXPAND: "sidebar_expand",
  SIDEBAR_COLLAPSE: "sidebar_collapse",
};

// Campaign related events
export const CAMPAIGN_EVENTS = {
  CAMPAIGN_CREATE: "campaign_create",
  CAMPAIGN_VIEW: "campaign_view",
  CAMPAIGN_EDIT: "campaign_edit",
  CAMPAIGN_DELETE: "campaign_delete",
};

// Company related events
export const COMPANY_EVENTS = {
  COMPANY_CREATE: "company_create",
  COMPANY_VIEW: "company_view",
  COMPANY_EDIT: "company_edit",
  COMPANY_DELETE: "company_delete",
};

// Metrics related events
export const METRICS_EVENTS = {
  METRICS_VIEW: "metrics_view",
  METRICS_FILTER: "metrics_filter",
  METRICS_EXPORT: "metrics_export",
};

// Form interaction events
export const FORM_EVENTS = {
  FORM_SUBMIT: "form_submit",
  FORM_ERROR: "form_error",
  FORM_SUCCESS: "form_success",
};
